<template>
    <div id="app" :class="getAppClass">
        <header v-if="showMenu" id="header" :class="getHeaderClass">
            <header-navigation></header-navigation>
            <div class="container">
                <router-link :to="{name: 'home'}" id="logo-mobile"></router-link>
                <form class="app-search-form">
                   <!-- <input type="text" class="form-control" placeholder="Поиск"/>
                    <button type="button" class="search-btn" title="Поиск">
                        <icon-base width="18" height="18" icon-name="Поиск"><icon-search/></icon-base>
                    </button>-->
                </form>
                <user-bar></user-bar>
            </div>
        </header>
        <nav id="nav" v-if="showMenu">
            <vuescroll :ops="ops">
                <router-link  :to="{name: 'home'}" id="logo"></router-link>
                <ul v-if="showMenu">
                    <li v-for="(item, index) in getMenu" :class="item.name + '-nav-item' + (item.disabled ? ' disabled' : '')" :key="index">
                        <component :is="item.disabled ? 'a' : 'router-link'" :to="{name: item.name}">
                            <span class="icon" v-html="item.icon"></span>
                            {{item.title}}
                        </component>
                    </li>
                </ul>
            </vuescroll>
        </nav>
        <router-view></router-view>
        <popup-component></popup-component>
        <notification-list></notification-list>

    </div>
</template>

<script>
    import vuescroll from 'vuescroll';
    import PopupComponent from "./Popup";
    import {mapState, mapGetters} from 'vuex'
    import HeaderNavigation from "./common/HeaderNavigation";
    import IconBase from "./common/IconBase";
    import IconSearch from "./common/icons/IconSearch";
    import NotificationList from "./NotificationList";
    import UserBar from "./common/UserBar";

    export default {
        components: {
            UserBar,
            NotificationList,
            IconBase,
            IconSearch,
            HeaderNavigation,
            vuescroll,
            PopupComponent
        },
        props: {
            menu: Array
        },
        data() {
            return {
                ops: {
                    vuescroll: {
                        mode: 'slide',
                        paging: false,
                        zooming: false,
                        scroller: {
                            bouncing: {
                                top: 0,
                                bottom: 0, left: 0, right: 0
                            },
                            preventDefault: false,
                            preventDefaultOnMove: true,
                        }
                    }
                }
            }
        },
        computed: {
            ...mapState({
                navVisible: state => state.navVisible,
                appClass: state => state.appClass,
                nav: state => state.headerNav,
            }),
            ...mapGetters([
                'getAppClass'
            ]),
            getMenu() {
                let temp = [];
                this.menu.map((item) => {
                    if (item.show) {
                        temp.push(item);
                    }
                });
                return temp
            },
            showMenu() {
                return !(this.$route.name === 'login-page' || this.$route.name === 'questionnaire' || this.$route.name === 'test' || this.$route.name === 'questionary');
            },
            getHeaderClass() {
                let headerClass = 'has-user-bar';
                headerClass +=  this.$store.state.knowledge.searchBarVisible ? ' mobile-hidden' : '';
                headerClass +=  this.nav.items.length ? ' has-app-sub-nav' : '';
                return headerClass
            }
        },

    }
</script>

<style scoped>
    @media screen and (max-width: 960px) {
        #app {
            padding-bottom: 0px;
        }

        .hide-nav #nav {
            display: none;
        }
    }
</style>